import { render, staticRenderFns } from "./StripeTest.vue?vue&type=template&id=d54dbf2e"
import script from "./StripeTest.vue?vue&type=script&lang=js"
export * from "./StripeTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports